import React, { Component } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/uiconfig';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withIntl, TranslatorContext } from '@jutro/locale';
import { Loader } from '@jutro/components';
import { Currency as CurrencyField } from 'gw-components-platform-react';
// eslint-disable-next-line import/no-unresolved
import styles from './BillingTransactions.module.scss';
import metadata from './BillingTransactions.metadata.json5';
import messages from './BillingTransactions.messages';

class BillingTransactions extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string,
                    account: PropTypes.shape({
                        accountNumber: PropTypes.string
                    })
                })
            }),
            billingData: PropTypes.shape({})
        }).isRequired,  
        intl: PropTypes.func.isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
    };

    state = {
        isLoading: true,
        billingTransactions: [],
        isbillingTransactionAvailable: true,
   };

    componentDidMount() {
       this.getBillingTransactionsData();
    };

    getBillingTransactionsData = async () => {
        const { fromAccountLanding } = this.props;

        const billingTransactionResponse = _.get(
            fromAccountLanding,
            'billingData.policyPeriodBillingSummaries[0].billingTransactions_Ext'
        );     
 
        if (!_.isEmpty(billingTransactionResponse) && billingTransactionResponse.length > 0) {            
            const billingTransactionsDataTable = this.getBillingTransactionsDataTable(billingTransactionResponse);
            this.setState({
                billingTransactions: billingTransactionsDataTable, 
                isLoading: false,
                isbillingTransactionAvailable: billingTransactionsDataTable.length > 0 // FB 16137
            });
        } else {
            this.setState({ isbillingTransactionAvailable: false, isLoading: false});
        }
    };

    getBillingTransactionsDataTable = (billingTransactionResponse, sorted) => {

        let transactionArrayResult = [];
        transactionArrayResult = billingTransactionResponse.map((data) => {
            const objData = {
                processDate: data.processDate, 
                transactionType: data.transactionType,
                amount: data.amount
            };
            return objData;
        });
        
        const sortedData = _.orderBy(transactionArrayResult, (o) => {
            return o.processDate;
          }, ['desc']);   

        return sortedData;
    };    

    getCell = (items, index, property) => {
        return (
            <span >
                {items[property.id]}
            </span>
        );
    };

    getFormattedDateField = (item, index, property) => {
        return this.getFormattedDate(item[property.id]);
    };
    getFormattedDate = (date) => {
        const { intl } = this.props;
        return intl.formatDate(new Date(date), { year: 'numeric', month: 'short', day: 'numeric' });
    };    

    getFormattedCurrency = (item, index, property) => {
       return (
            <span>
                <CurrencyField
                    id={`currency_${index}`}
                    value={item[property.id]}
                    readOnly
                    hideLabel
                    showOptional={false}
                />
            </span>
        );        
    };

    render() {
        const {
            isLoading,
            billingTransactions,
            isbillingTransactionAvailable
        } = this.state;
        const translator = this.context;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        const overrides = {
            billingTransactionsTable : {
                data: billingTransactions,
            },
            billingContainer : {
                visible : isbillingTransactionAvailable
            },
            billingTransEmptyContainer: {
                visible: !isbillingTransactionAvailable
            },
            warningMessage: {
                value: translator(messages.noBillingTransactionDataLabel)
            }
        };

        const resolvers = {
            resolveComponentMap: {},
            resolveCallbackMap: {
                getCell: this.getCell,
                getFormattedCurrency: this.getFormattedCurrency,
                getFormattedDate: this.getFormattedDateField,
            },
            resolveClassNameMap: styles 
        };

        return (
            <div className={styles.billingtransactions}>
                <MetadataContent
                    uiProps={metadata.pageContent}
                    overrideProps={overrides}
                    {...resolvers}
                />
            </div>
        );
    }
}

export default withRouter(withIntl(withAuthenticationContext(BillingTransactions)));
